/**
 * This file is part of the JS Money library
 *
 * Copyright (c) 2014 David Kalosi
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

module.exports = require('./money');



//////////////////
// WEBPACK FOOTER
// ./~/js-money/lib/index.js
// module id = 35
// module chunks = 2